import { LINK } from '@constants';
import {
  AutoClickViewing,
  AutoViewing,
  ClickViewing,
  FacebookColor,
  Icon,
  InstagramColor,
  NaverColor,
  PostingViewing,
  Row,
  ThreadsColor,
  ViewupPlusColor,
  YoutubeColor,
} from '@viewup/ui';
import { ViewingPlatform, ViewingType } from 'app/viewing/_entities/common';

export const viewingMenus = [
  {
    icon: <Icon size='S' source={ClickViewing} />,
    link: LINK.VIEWING_CLICK,
    platform: [
      <Icon key={ViewingPlatform.INSTAGRAM} size='XS' source={InstagramColor} />,
      <Icon key={ViewingPlatform.YOUTUBE} size='XS' source={YoutubeColor} />,
      <Icon key={ViewingPlatform.FACEBOOK} size='XS' source={FacebookColor} />,
      <Icon key={ViewingPlatform.THREADS} size='XS' source={ThreadsColor} />,
      <Icon key={ViewingPlatform.NBLOG} size='XS' source={NaverColor} />,
    ],
    point: '0 ~ 0',
    subTitle: '클릭 한번으로\n쉽게 포인트 적립',
    title: '클릭뷰업',
    type: ViewingType.CLICK,
  },
  {
    icon: <Icon color='icon.success' size='S' source={PostingViewing} />,
    link: LINK.VIEWING_POST_APPLY_LIST,
    platform: [<Icon key={ViewingPlatform.NBLOG} size='XS' source={NaverColor} />],
    point: '0 ~ 0',
    subTitle: '블로그 포스팅으로\n포인트 적립하기',
    title: (
      <Row alignItems='center' gap={4}>
        포스팅뷰업
      </Row>
    ),
    type: ViewingType.POST,
  },
  {
    icon: <Icon size='S' source={AutoViewing} />,
    platform: [
      <Icon key={ViewingPlatform.INSTAGRAM} size='XS' source={InstagramColor} />,
      <Icon key={'viewupPlus'} size='XS' source={ViewupPlusColor} />,
    ],
    point: '0 ~ 0',
    subTitle: '매일매일 쌓이는\n포인트',
    title: '보너스뷰업',
    type: ViewingType.AUTO,
  },
  {
    icon: <Icon size='S' source={AutoClickViewing} />,
    link: LINK.VIEWING_AUTO_SETTING,

    platform: [
      <Icon key={ViewingPlatform.INSTAGRAM} size='XS' source={InstagramColor} />,
      <Icon key={ViewingPlatform.YOUTUBE} size='XS' source={YoutubeColor} />,
      <Icon key={ViewingPlatform.FACEBOOK} size='XS' source={FacebookColor} />,
      <Icon key={ViewingPlatform.THREADS} size='XS' source={ThreadsColor} />,
      <Icon key={ViewingPlatform.NBLOG} size='XS' source={NaverColor} />,
    ],
    point: '0 ~ 0',
    subTitle: '자동으로 천천히\n클릭하기',
    title: '오토뷰업',
    type: ViewingType.MACRO,
  },
];
